import { BoxSelect } from "lucide-react";
import { Tooltip } from "components/common/Tooltip";
import type { ExportImpactChipProps } from "./types";

export const ExportImpactChip = ({ label, tooltip }: ExportImpactChipProps) => {
  return (
    <Tooltip label={tooltip}>
      <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-xs text-amber-700">
        <BoxSelect size={12} className="shrink-0" />
        {label}
      </span>
    </Tooltip>
  );
};
